<template minapp='mpx' xlang='wxml'>
	<!-- 列表 -->
	<view>
		<view id="{{trainConf.keyTitle}}" style="height:{{windowHeight}}px">
			<es-layout
				leftArrow="{{true}}"
        navbarClickLeft="{{goback}}"
				navbarTitle="我的行程"
				custom-class="my-class"
        navbarStyle="{{navbarStyle}}"
				loadingImageUrl="{{loadingImg}}"
				blankPageType="{{blankPageType}}"
				useBlankPage="{{pageFailed}}"
				useDefaultNavbar="{{!pageFailed}}"
				bindscrolltobottom="onScrollToBottom"
				bind:blank-retry="fetchOrderList(trainConf)"
				scrollTop="{{trainConf.pageScrollHeight}}"
			>
				<!-- 无订单 -->
				<view class="order-tip" wx:if="{{isShowEmpty}}">
          <login-card wx:if="{{needMandatoryLogin}}" customStyle="{{emptyCustomStyle}}"/>
          <!-- <tickets12306-entrance wx:else needMargin /> -->
					<image
						class="null-image"
						src="https://pt-starimg.didistatic.com/static/starimg/img/8jPyrnQfol1642402065727.png"
					/>
					<view class="null-title">暂无{{ trainConf.name }}行程</view>
					<view class="null-context">当前暂无{{ trainConf.name }}行程记录</view>
          <view wx:if="{{showLogout}}" class="log-out" bindtap="logout">
            <view class="log-out-btn">退出登录</view>
          </view>
				</view>
				<view
					wx:else
					class="card-main"
					bindtouchend="touchEnd"
					bindtouchmove="touchMove"
					bindtouchstart="touchStart"
          bindtap="handClick"
				>
					<!-- 下拉刷新的box -->
					<view class="card-main-pull" wx:style="transform:{{transformY}};">
						<image src="{{loadingIcon}}" class="pulldown-loading" />
						<view class="pulldown-text">松开立即刷新</view>
					</view>
					<view class="card-container" wx:style="transform:{{transformY}};">
            <login-card wx:if="{{needMandatoryLogin}}" customStyle="{{customStyle}}"/>
            <!-- <tickets12306-entrance wx:else /> -->
						<view wx:for="{{trainConf.allData}}" wx:key="{{index}}" wx:for-item="titleItem">
							<view class="title" wx:if="{{titleItem.isMust && titleItem.data.length}}">
								{{ titleItem.title }}
							</view>
							<view
								class="card-mtop"
								wx:for="{{titleItem.data}}"
								wx:key="order_id"
								wx:for-item="orderItem"
							>
								<es-card-del
                  wx:if="{{!orderItem.union_journey}}"
									index="{{index}}"
									item="{{ { orderItem, index, titleItem } }}"
									bind:click-right="delData"
									bind:click-left="goDetail"
								>
									<view slot="mainContext" class="main-context">
										<component is="{{trainConf.component}}" item="{{orderItem}}"></component>
									</view>
									<view slot="delContext" class="del-box">
										<view>删除</view>
									</view>
								</es-card-del>
                <transfer-train-order-card 
                  wx:else 
                  orderItem="{{orderItem}}" 
                  orderIndex="{{index}}" 
                  titleItem="{{titleItem}}"
                  bind:delData="delData"
                  bind:goDetail="goDetail"
                />
							</view>
						</view>
					</view>
					<!-- 加载状态 -->
					<view class="order-loading">{{ loadingText }}</view>
          <view wx:if="{{showLogout}}" class="log-out" bindtap="logout">
            <view class="log-out-btn">退出登录</view>
          </view>
				</view>
			</es-layout>
		</view>
	</view>
	<!-- 弹窗部分 -->
	<es-dialog
		showCancelButton
		showConfirmButton
		title="温馨提示"
		show="{{show}}"
		algin="{{algin}}"
		bind:cancel="onCancel"
		bind:confirm="onConfirm"
	>
		<view slot="content">{{ dialogText }}</view>
	</es-dialog>
</template>

<script>
  import trainConf from './lib/trainConf'
  import store from '@/store'
  import usexStore from '@/config/usex/lib/store'
  import { addRavenPhoneAndUid } from '@/common/raven-init/init'
  import storage from '@didi/es-mpx-storage'
  import { versionValid } from '@didi/es-mpx-shared'
  import { xenv, alimpReady } from '@didi/webx-js'
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import { formatDate, getFullDate, calcDateNum } from '@didi/es-mpx-shared/lib/date'
  import { innerRouter, pagePath } from '@/common/jump'
  import { goback, query, is } from "@didi/spring-base";

  let copyTrainConf = JSON.parse(JSON.stringify(trainConf))
  let timer = null
  createPage({
    data: {
      trainConf,
      pageFailed: false,
      loadingStatus: false, // 加载状态
      loadingText: '', // 加载文案
      show: false, // 弹窗的控制
      dialogText: '', // 弹窗的文案
      algin: 'left', // 弹窗的对齐方式
      isDelDialog: false, // 是否是删除订单的弹窗
      currentOrderDetail: {}, // 当前订单的数据
      paddingTop: 96,
      windowHeight: 0,
      statusBarHeight: 0,
      refresherTriggered: false, // 设置当前下拉刷新状态
      touchStartHeight: 0,
      clientY: 0,
      changeClientY: 0,
      pulldownStatus: 1, // pulldownStatus 的两个状态，0: 下拉刷新, 1: 触底加载
      loadingImg: 'https://img-hxy021.didistatic.com/static/starimg/img/4Bn6domBsM1672373833796.png',
      loadingIcon: 'https://pt-starimg.didistatic.com/static/starimg/img/r2q8WK5PAH1652165229145.png',
      platform: 'android',
      needMandatoryLogin: false,
      customStyle: {
        'border-radius': '8px'
      },
      emptyCustomStyle: {
        'border-radius': '8px',
        'margin': '8px 12px 0 12px'
      }
    },
    onShow() {
      //如果没有登陆 那么吊起登陆
      if (!this.isLogin) {
        this.checkLoginAndfetchOrderList()
      }else{
        this.fetchOrderList(this.trainConf)
      }
    },
    attached() {
      this.getSystemInfo()
      //todo 为了防止拉起带来的留底空白问题
      setTimeout(() => {
        this.getSystemInfo()
      }, 1500);
      this.setOpenId()
    },
    computed: {
      ...store.mapState({
        token: 'user.token',
        userInfo: 'user.userInfo',
      }),
      isLogin() {
        return this.token || this.userInfo?.token
      },
      navbarStyle() {
        return { background: '#fff' }
      },
      // 列表偏移配置
      transformY() {
        if (this.platform === 'ios') {
          return 'translateY(0px)'
        } else {
          return `translateY(${this.changeClientY}px)`
        }
      },
      // 当前页面状态
      blankPageType() {
        return this.trainConf.isLoading ? 'blank-page' : 'category-loading'
      },
      // 是否展示空数据提示
      isShowEmpty() {
        return (
          !this.trainConf.isLoading &&
          !(this.trainConf.allData[0].data.length || this.trainConf.allData[1].data.length)
        )
      },
      // 当前是否是支付宝独立机火小程序环境
      showLogout() {
        const { appid } = this.$mpxRoute.query || {}
        return appid === '121735'
      },
    },
    methods: {
      checkLoginAndfetchOrderList(){
        usexStore.dispatch('getToken', true).then((res) => {
          addRavenPhoneAndUid(res)
          this.fetchOrderList(this.trainConf)
        })
      },
      handClick(){
        if (!this.isLogin) {
          this.checkLoginAndfetchOrderList()
        }
      },
      goback() {
        const isTravelGuide = query().from_page === 'travel_guide'
        if(isTravelGuide) goback()
        else innerRouter.replace(pagePath().HOME)
      },
      touchStart(e) {
        this.touchStartHeight = this.trainConf.recordScrollHeight
        this.clientY = e.changedTouches?.[0].clientY
      },
      touchMove(e) {
        let clientY = e.changedTouches?.[0].clientY
        // 如果是从顶部开始滑动，并且方向为朝下，执行以下逻辑
        if (this.touchStartHeight < 40 && this.clientY < clientY) {
          if (this.platform !== 'ios') {
            let changeY = Math.trunc(clientY - this.clientY)
            this.changeClientY = changeY > 90 ? 90 : changeY
            this.pulldownStatus = changeY > 90 ? 0 : 1
          }
        }
      },
      touchEnd(e) {
        let list = document.querySelector('.card-container')?.getBoundingClientRect()
        let clientY = e.changedTouches?.[0].clientY
        let changeY = Math.trunc(clientY - this.clientY)
        if (this.platform !== 'ios') this.changeClientY = 0
        if (this.touchStartHeight < 40) {
          if (changeY > 90 && list?.y > 90) {
            this.pulldownStatus = 0
            this.refreshList()
          } else {
            this.pulldownStatus = 1
          }
        }
      },
      // 获取系统相关信息
      getSystemInfo() {
        mpx.getSystemInfo().then((e) => {
          const height = Math.ceil(Number(e.statusBarHeight) / 2)
          this.platform = e?.platform
          this.statusBarHeight = height || 0
          this.windowHeight = Number(e?.windowHeight ?? 0)
        })
      },
      // 设置 openId
      setOpenId() {
        if (!storage) return console.log('没有 storage 啊')
        mpx.use(storage)
        const { openid } = this.$mpxRoute.query || {}
        openid && mpx.$storage.session.set('es_h5_c_openid', openid)
      },
      // 滚动到底部事件
      onScrollToBottom({ detail: e }) {
        if (!this.loadingStatus) this.loadMore()
      },
      // 触发下拉刷新事件
      async refreshList() {
        if (this.loadingStatus) return
        if (__mpx_mode__ === 'web') mpx.showLoading()

        // 请求第一页数据
        this.trainConf.state.last_order_id = 0
        // this.trainConf.allData[0].data.splice(0)
        // this.trainConf.allData[1].data.splice(0)

        await this.fetchOrderList(this.trainConf, { isInit: true })
        this.changeClientY = 0
        if (__mpx_mode__ === 'web') setTimeout(() => mpx.hideLoading(), 300)
      },
      // 发出请求
      getRequest(url, params, type) {
        const getDataType = type === 'get' ? mpx.$http.get : mpx.$http.post
        const option = type === 'get' ? { params } : { data: params }
        return mpx.$http[type](url, option).then((res) => {
          const { code: errcode, message, data } = res
          if (+errcode !== 0) {
            this.dialogText = message
            this.isDelDialog = false
            this.algin = 'center'
            this.handleClick()
          }
          return res
        })
      },
      // 获取订单列表接口请求
      async fetchOrderList(conf, opts = {}) {
        const { url, type, keyTitle, state } = conf
        await this.getRequest(url, state, type)
          .then((res) => {
            const { code, data } = res
            this.needMandatoryLogin = data?.need_mandatory_login
            if (+code !== 0) return (this.pageFailed = true)
            switch (keyTitle) {
              case 'train':
                this.changeTrainData(data, conf, opts)
                break
              default:
                break
            }
          })
          .catch((err) => {
            console.log('订单列表接口请求失败', err)
            this.pageFailed = true
            mpx.hideLoading()
          })
          .finally(() => {
            this.loadingText = ''
            this.loadingStatus = false
          })
      },
      // 加载更多
      async loadMore() {
        this.loadingStatus = true
        if (this.trainConf?.hasMore) {
          this.loadingText = '数据加载中...'
          await this.fetchOrderList(this.trainConf)
        } else {
          this.loadingText = '没有更多数据了'
          setTimeout(() => (this.loadingStatus = false), 1000)
        }
      },
      // 删除订单点击弹窗
      delData(data) {
        let {
          index,
          titleItem: { type },
          orderItem: { status, order_id }
        } = data.detail
        let isCanDel = true
        switch (this.trainConf?.keyTitle) {
          case 'train':
            if ([5, 6, 7, 11, 13].indexOf(+status) === -1) isCanDel = false
            break
          default:
            break
        }
        this.currentOrderDetail = { order_id, isCanDel, index, type }
        // 删除点击时先弹窗提示
        this.dialogText =
          '删除订单后将不能恢复，可能影响订单详情信息查看、客服咨询、开票等功能使用，请谨慎操作'
        this.isDelDialog = true
        this.algin = 'center'
        this.handleClick()
      },
      // 跳转订单详情页面
      async goDetail(data) {
        let {
          orderItem: { order_id = '' }
        } = data.detail
        innerRouter.push(pagePath().ORDERDETAIL, { order_id })
      },
      // 弹窗
      handleClick() {
        this.show = true
      },
      // 弹窗点击确认
      onConfirm() {
        this.show = false
        if (this.isDelDialog) this.fetchDelOrder()
      },
      // 弹窗点击取消
      onCancel() {
        this.show = false
      },
      // 删除订单接口请求
      async fetchDelOrder() {
        const { order_id, isCanDel, index, type } = this.currentOrderDetail
        if (!isCanDel) {
          this.algin = 'center'
          this.isDelDialog = false
          this.dialogText = '当前状态订单不能删除，删除后可能影响您的订单基础功能使用'
          setTimeout(() => this.handleClick())
          return
        }

        // 如果能删除订单，就发出删除请求
        const { delUrl, delType, keyTitle } = this.trainConf
        const paramsData = { order_id }

        await this.getRequest(delUrl, paramsData, delType)?.then((res) => {
          const { code, message } = res
          if (+code === 0)
            this.$delete(this.trainConf?.allData?.[type === 'current' ? 0 : 1]?.data, index)
        })
      },
      // 火车票处理数据 isInit 为 true 代表先清除列表数据
      changeTrainData(data, trainConf, { isInit = false }) {
        if (data?.list?.length > 0) {
          if (isInit) {
            trainConf.allData[0].data.splice(0)
            trainConf.allData[1].data.splice(0)
          }
          if (data.last_order_id !== trainConf.state.last_order_id || isInit) {
            trainConf.hasMore = data.has_more
            trainConf.state.last_order_id = data.last_order_id
            data.list.forEach((item, index) => {
              // const week = getFullDate(start_time).weekName
              const start_time = Number(item.start_time) * 1000
              const week = ['日', '一', '二', '三', '四', '五', '六']?.[new Date(start_time)?.getDay()]
              item.start_time = formatDate(start_time, 'M月dd日 周' + week + ' hh:mm ')
              trainConf.allData[0].data.push(item)
            })
          }
        }
        trainConf.isLoading = false
      },
      // 页面登出
      logout() {
        // 对当前的query进行参数删除
        const link = 'https://railway.xiaojukeji.com/pages/home/index'
        alimpReady(() => {
          window.my && window.my.redirectTo({
            url: `/logout/pages/index?back_url=${encodeURIComponent(link)}`,
            success(res) {
              this.SET_LOGIN_EMPTY()
              console.log(res, '登出成功')
            },
            fail(err) {
              console.log(err, '登出失败')
            },
          })
        })
      },
    }
  })
</script>

<style lang='stylus' scoped>
  .log-out
    margin: 20px 0;
    border: 1px solid #CCCCCC;
    border-radius: 8px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    .log-out-btn
      color #666
  .my-class
    height 100%
    font-family PingFangSC-Regular
  .order-loading
    height 40px
    width 100%
    text-align center
    line-height 40px
    font-size 14px
    color #666
  .navbar
    z-index 100
  .order-tip
    text-align center
    font-weight 400
    height 100%
    background #F3F4F5
  .null-image
    height 100px
    width 100px
    margin-top 172px
  .null-title
    color #333
    font-size 14px
    margin 16px 0 2px 0
    height 20px
    ling-height 20px
  .null-context
    color #999
    font-size 12px
  .card-main
    margin 0 12px
    transform translateY(-40px)
    min-height calc(100% + 1px)
  .card-container
    flex 1
  .title
    padding-top 8px
    font-size 14px
    color #999
  .card-mtop
    padding-top 10px
  .del-box
    display flex
    justify-content flex-end
    align-items center
    border-radius 9px
    font-size 14px
    font-weight 500
    font-family PingFangSC-Regular
    height 100%
    background #F93822
    padding-right 24px
  .pulldown-text
    color #666
    font-size 14px
    padding-right 28px
  .card-main-pull
    display flex
    justify-content center
    align-items center
    width 100%
    height 40px
  .pulldown-loading
    width 20px
    height 20px
    margin-right 12px
    animation spin 2s linear infinite
  @keyframes spin
    0%
      transform rotate(0deg)
    100%
      transform rotate(360deg)
</style>

<script name="json">
  module.exports = {
    onReachBottomDistance: 0,
    usingComponents: {
      'es-dialog': '@didi/es-mpx-ui/lib/dialog/index',
      'es-card-del': '@didi/es-mpx-ui/lib/card-del/index',
      'train-card': './components/newTrainOrderCard.mpx',
      'transfer-train-order-card': './components/transfer-train-order-card.mpx',
      'login-card': '@/components/login-card',
      'tickets12306-entrance': './components/tickets12306-entrance.mpx',
    }
  }
</script>
